
<script>
import { defineComponent, inject, onBeforeUnmount, watch } from 'vue'
import { cmsasset } from '@kit/utils/Formats'
import { slugPageSetup } from '@kit/utils/Setup'
import { sleep } from '@kit/utils/Sleep'


import SimpleTabsBehavior from '@kit/utils/SimpleTabBehavior'
import Scroller from '@kit/utils/Scroller'

import Shine from '@kit/components/Shine.vue'
import '@css/round-valley-indian-tribes.df049ad5f.css'
import '@css/rvit.css'

export default defineComponent({
  name: "RVITGovernment",

  setup() {

    let scroller = null 
    let simpleTabBehavior = null 

    const createFXManagers =() => {
      if(!scroller) {
        scroller = new Scroller()
      }
      if(!simpleTabBehavior) {
        simpleTabBehavior = new SimpleTabsBehavior()
      }     
    }

    const { id, prefetch } = slugPageSetup({
      routeParam: 'slug',
      prefetchKey: 'rvitGovernment',
      mounted() {
        createFXManagers()
      },
      metadata(rvitGovernment, meta) {
        const seo = rvitGovernment.seo_set[0]
        meta.addTitle(seo.page_title)
        meta.addCanonical()
        meta.addMetaItem([
          { name:'description', content: seo.page_description },
          { name:'og:title', content: seo.open_graph_title },
          { name:'og:description', content: seo.open_graph_description }
        ])

        if(seo.open_graph_image) {
          meta.addMetaItem([
            { name:'og:image', content: cmsasset(seo.open_graph_image.guid) },
            { name:'og:image:alt', content: seo.open_graph_image_alt } 
          ])
        }
      }
    })

    onBeforeUnmount(() => {
      if(scroller) {
        scroller.destroy()
        scroller = null 
      }
      if(simpleTabBehavior) {
        simpleTabBehavior.destroy()
        simpleTabBehavior = null
      }
    })

    const applyPageFX = () => {
      scroller.register('.fx-scroller-behavior')
      simpleTabBehavior.register('.fx-simple-tab-behavior')
    }
  
    //Watch the prefetch. When the data loads and when it does
    watch(prefetch, async(_newVal, _oldVal) => {
      if(prefetch.value && prefetch.value.rvitGovernment) {
        createFXManagers()
        if(scroller && simpleTabBehavior) {
          await sleep(500)
          applyPageFX()
        }
      }
    }, { immediate:true })



    return { prefetch, id }
  },
  components: {
    Shine
  }

});
</script>

<style>
  .simple-tabs-flash-spread {
    background:white;
    display:none;
    position:absolute;
    top:0px;
    bottom:0px;
    left:0px;
    right:0px;
  }
</style>

<template>
  <div v-if="prefetch && prefetch.rvitGovernment" v-html="prefetch.rvitGovernment.main_html"></div>
  <div v-else class="sb sb-v sb-alt2 sb-align-ch sb-g30" style="margin-bottom:100px;">
    <Shine class="sb" w="50%" h="100px" shine="light" />
    <Shine class="sb" w="50%" h="100px" shine="light" />
    <Shine class="sb" w="50%" h="100px" shine="light" />
  </div>
</template>